var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-modal" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("step-two"),
      _vm._v(" "),
      _c(
        "k-button",
        {
          staticClass: "onboarding-action-button",
          attrs: { "no-icon": "", "data-cy": "onboarding-action-button" },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v("\n    Vamos Lá\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n      Bem vindo ao seu clube de vantagens\n    ")
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "subtitle" }, [
        _vm._v(
          "\n      Aqui você encontra os melhores descontos para utilizar nas suas marcas favoritas\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8de78418", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8de78418","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Onboarding/OnboardingModal.vue
// module id = 2161
// module chunks = 1610